import { computed, ref } from 'vue'

interface CanvasOverlay {
  id: string
  fullscreen?: boolean
  edit_mode?: boolean
  component_id?: string
  section_id?: string
  position?: {
    left?: number | string
    right?: number | string
    top?: number | string
    bottom?: number | string
  }
}

const initialCanvas = ref<CanvasOverlay | undefined>(undefined)

export default () => {
  const openCanvasOverlay = ({ id, fullscreen, edit_mode, component_id, section_id, position }: CanvasOverlay) => {
    initialCanvas.value = { id, fullscreen, edit_mode, component_id, section_id, position }
  }

  const closeCanvasOverlay = () => {
    initialCanvas.value = undefined
  }

  return {
    isCanvasOverlayOpen: computed(() => initialCanvas.value !== undefined),
    initialCanvas: computed(() => initialCanvas.value),
    openCanvasOverlay,
    closeCanvasOverlay,
  }
}
